
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from 'react';
import { _getURL } from "@/api/index";
import Redux, { updatePath } from "@/action";
import _ from 'lodash';
import { BottomNavigation } from '@/components/common/navigation';
import Link from 'next/link';
import { pageLink } from '@/config/site';
import { PopularCarBrands, VehicleBrandList, RecommendedCars } from '@/components/vehicle';
import { _postURL } from '../api';
import { useRouter } from 'next/router';
import { _stringToLink, _getAllVehicleTopList, _getAllVehicleBrandList, _getPlacement } from '../../libraries/common';
import { Footer } from '../../components/common/footer';
import { HeaderBack } from '../../components/common/header';
import { AllMeta } from '@/components/common/meta';
import Head from 'next/head';
import { placementArea } from '../../config/site';
import { PlacementBanner } from '../../components/placement';
import { MyBody } from '../../components/body/body';
import { CustomLink } from '../../components/app/customLink';
import { customRouterLink } from '../../libraries/appCommon';

const vehicleFilterPriceSelect = [
    {name: "0-40k", value: "0-40k", type: "price"},
    {name: "40-60k", value: "40-60k", type: "price"},
    {name: "60-90k", value: "60-90k", type: "price"},
    {name: "90-120k", value: "90-120k", type: "price"},
]

const vehicleFilterBodyTypeSelect = [
    {name: "Sedan", value: "sedan", type: "bodyType"},
    {name: "Hatchback", value: "hatchback", type: "bodyType"},
    {name: "MPV", value: "mpv", type: "bodyType"},
    {name: "SUV", value: "suv", type: "bodyType"},
]

export default function Index(props) {
    const { t, device, session } = props;
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true);
    const router = useRouter()

    useEffect(()=>{
        const fetchData = async() => {
            try{
                if(_.isEmpty(store?.path?.dataAllVehicleBrandList)){
                    await _getAllVehicleBrandList(dispatch);
                }
                if(store?.path?.dataAllVehicleTopList == undefined){
                    await _getAllVehicleTopList(dispatch);
                }
                if(store?.path?.dataPlacement == undefined){
                    await _getPlacement(dispatch)
                }
            } catch(error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    },[])

    const _handleClickBrandItemLink = async(value) =>{
        if(!_.isEmpty(value?.brand_custom_url)){
            customRouterLink({router: router, href: pageLink.vehicle.vehicleMidUrl + value?.brand_custom_url})
            // router.push(pageLink.vehicle.vehicleMidUrl + value?.brand_custom_url);
        }
    }

    return (
        <>
            <AllMeta
                title={t('vehiclePage_meta_title')}
                description={t('vehiclePage_meta_description')}
                keyword={t('vehiclePage_meta_keyword')}
            />
            <Head><title>{t('vehiclePage_title')}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack t={t} />
                }
                navigationComponent={
                    <BottomNavigation t={t} />
                }
                showNavigation={false}
            >
                <PopularCarBrands data={store?.path?.dataAllVehicleTopList?.brand ?? []} isSingleRow={true} t={t} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
                <RecommendedCars data={store?.path?.dataAllVehicleTopList?.model ?? []} t={t} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
                <div className='containerPadding'>
                    <div className='vehiclePage_lookCar_titleRow'>
                        <p className='fontSize_16 fontWeight_bold'>
                            {t('look_for_your_car')}
                        </p>
                        <CustomLink href={pageLink.vehicle.filter}>
                            <div className='vehiclePage_lookCar_goFilterIcon cursorPointer'>
                                <img 
                                    src={`/assets/images/right_circle_icon.svg`}
                                />
                            </div>
                        </CustomLink>
                    </div>
                    <div className='vehiclePage_lookCar_body'>
                        {
                            _.reduce(vehicleFilterPriceSelect, (result, value, key) => {
                                result.push(
                                    <CustomLink key={key} href={`${pageLink.vehicle.filterResult}?price=${value.value}`}>
                                        <div  className='vehiclePage_lookCar_button cursorPointer'>
                                            <p className='fontSize_14 vehiclePage_lookCar_button_text'>
                                                {value.name}
                                            </p>
                                        </div>
                                    </CustomLink>
                                )
                                return result
                            },[])
                        }
                    </div>
                    <div className='vehiclePage_lookCar_body vehiclePage_lookCar_body2'>
                        {
                            _.reduce(vehicleFilterBodyTypeSelect, (result, value, key) => {
                                result.push(
                                    <CustomLink key={key} href={`${pageLink.vehicle.filterResult}?bodytype=${value.value}`}>
                                        <div className='vehiclePage_lookCar_button cursorPointer'>
                                            <p className='fontSize_14 vehiclePage_lookCar_button_text'>
                                                {value.name}
                                            </p>
                                        </div>
                                    </CustomLink>
                                )
                                return result
                            },[])
                        }
                    </div>
                </div>
                <div className='mt_25'>
                    <PlacementBanner
                        // can't pass object because inside using memo
                        loading={store?.path?.dataPlacement == undefined ? true : false}
                        area={placementArea?.vehiclePage_beforeBrandList} 
                        placement_id={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.placement_id}
                        type={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.type}
                        image_path={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.image_path}
                        url={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.url}
                        script={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.script}
                    />
                </div>
                <div className='vehiclePage_vehicle_brandlistMargin'>
                    <VehicleBrandList data={store?.path?.dataAllVehicleBrandList ?? []} handleClickBrandItem={_handleClickBrandItemLink} willForceRefresh={true} loading={loading} t={t} />
                </div>
            </MyBody>
        </>
    )
    
    // return (
    //     <>
    //         <AllMeta
    //             title={t('vehiclePage_meta_title')}
    //             description={t('vehiclePage_meta_description')}
    //             keyword={t('vehiclePage_meta_keyword')}
    //         />
    //         <Head><title>{t('vehiclePage_title')}</title></Head>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer bodyContainerHasBottomNavigation'>
    //                 <HeaderBack t={t} />
    //                 <PopularCarBrands data={store?.path?.dataAllVehicleTopList?.brand ?? []} isSingleRow={true} t={t} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
    //                 <RecommendedCars data={store?.path?.dataAllVehicleTopList?.model ?? []} t={t} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
    //                 <div className='containerPadding'>
    //                     <div className='vehiclePage_lookCar_titleRow'>
    //                         <p className='fontSize_16 fontWeight_bold'>
    //                             {t('look_for_your_car')}
    //                         </p>
    //                         <Link href={pageLink.vehicle.filter}>
    //                             <div className='vehiclePage_lookCar_goFilterIcon cursorPointer'>
    //                                 <img 
    //                                     src={`/assets/images/right_circle_icon.svg`}
    //                                 />
    //                             </div>
    //                         </Link>
    //                     </div>
    //                     <div className='vehiclePage_lookCar_body'>
    //                         {
    //                             _.reduce(vehicleFilterPriceSelect, (result, value, key) => {
    //                                 result.push(
    //                                     <Link key={key} href={`${pageLink.vehicle.filterResult}?price=${value.value}`}>
    //                                         <div  className='vehiclePage_lookCar_button cursorPointer'>
    //                                             <p className='fontSize_14 vehiclePage_lookCar_button_text'>
    //                                                 {value.name}
    //                                             </p>
    //                                         </div>
    //                                     </Link>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                     <div className='vehiclePage_lookCar_body vehiclePage_lookCar_body2'>
    //                         {
    //                             _.reduce(vehicleFilterBodyTypeSelect, (result, value, key) => {
    //                                 result.push(
    //                                     <Link key={key} href={`${pageLink.vehicle.filterResult}?bodytype=${value.value}`}>
    //                                         <div className='vehiclePage_lookCar_button cursorPointer'>
    //                                             <p className='fontSize_14 vehiclePage_lookCar_button_text'>
    //                                                 {value.name}
    //                                             </p>
    //                                         </div>
    //                                     </Link>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                 </div>
    //                 <div className='mt_25'>
    //                     <PlacementBanner
    //                         // can't pass object because inside using memo
    //                         loading={store?.path?.dataPlacement == undefined ? true : false}
    //                         area={placementArea?.vehiclePage_beforeBrandList} 
    //                         placement_id={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.placement_id}
    //                         type={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.type}
    //                         image_path={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.image_path}
    //                         url={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.url}
    //                         script={store?.path?.dataPlacement?.[placementArea?.vehiclePage_beforeBrandList]?.script}
    //                     />
    //                 </div>
    //                 <div className='vehiclePage_vehicle_brandlistMargin'>
    //                     <VehicleBrandList data={store?.path?.dataAllVehicleBrandList ?? []} handleClickBrandItem={_handleClickBrandItemLink} willForceRefresh={true} loading={loading} t={t} />
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //             <BottomNavigation t={t} />
    //         </div>
    //     </>
    // )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
        ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}